export function initFaqBlocks() {
	const blocks = document.querySelectorAll('[data-faq-block]');
	if (!blocks.length) {
		return;
	}

	blocks.forEach((block) => {
		initFaqBlock(block);
	});
}

function initFaqBlock(block) {
	const items = Array.from(block.querySelectorAll('.faq-block__item'));
	if (!items.length) {
		return;
	}

	const setState = (item, isOpen) => {
		const trigger = item.querySelector('[data-faq-trigger]');
		const content = item.querySelector('[data-faq-content]');
		if (!trigger || !content) {
			return;
		}

		item.classList.toggle('is-open', isOpen);
		trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		content.hidden = !isOpen;
	};

	items.forEach((item) => {
		const trigger = item.querySelector('[data-faq-trigger]');
		if (!trigger) {
			return;
		}

		trigger.addEventListener('click', () => {
			const isOpen = item.classList.contains('is-open');
			setState(item, !isOpen);
		});
	});
}
